(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecbf3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecbf3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("31lGp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $752f6a733b81648a$export$2e2bcd8739ae039; });
const $752f6a733b81648a$var$meta = document.head ? document.head.querySelector("meta[name=bb-view-name]") : undefined;
var $752f6a733b81648a$export$2e2bcd8739ae039 = $752f6a733b81648a$var$meta ? $752f6a733b81648a$var$meta.content : "";

});

parcelRegister("M3cyx", function(module, exports) {

$parcel$export(module.exports, "statsdApiClient", function () { return $331b124e6c1e050c$export$a01478d561e38286; });
parcelRequire("k5QC7");
var $dxTmL = parcelRequire("dxTmL");

var $kvnVB = parcelRequire("kvnVB");

var $628YF = parcelRequire("628YF");
const $331b124e6c1e050c$var$onError = (e)=>{
    (0, $628YF.captureExceptionWithTags)(e, {
        component: "metrics"
    });
};
const $331b124e6c1e050c$var$request = {
    url: `${(0, $kvnVB.settings)().API_CANON_URL}/internal/metrics/statsd/`,
    init: {
        headers: {
            "Content-Type": "application/json"
        }
    }
};
const $331b124e6c1e050c$export$a01478d561e38286 = new (0, $dxTmL.default)($331b124e6c1e050c$var$request, {
    onError: $331b124e6c1e050c$var$onError
});

});
parcelRegister("k5QC7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return (parcelRequire("dxTmL")).default; });

var $dkt0q = parcelRequire("dkt0q");

var $dxTmL = parcelRequire("dxTmL");

});
parcelRegister("dkt0q", function(module, exports) {

});

parcelRegister("dxTmL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5fd69b7d1dfb75f7$export$2e2bcd8739ae039; });

var $ausL7 = parcelRequire("ausL7");
function $5fd69b7d1dfb75f7$var$extractSampleRate(options = {}) {
    return typeof options.sampleRate === "number" ? options.sampleRate : 1;
}
function $5fd69b7d1dfb75f7$var$normalizeCounterData(data) {
    if (typeof data === "string") return {
        [data]: 1
    };
    else if (Array.isArray(data)) return data.reduce((acc, v)=>({
            ...acc,
            [v]: 1
        }), {});
    return data;
}
/**
 * This simulates the same sampling that datadog's statsd agent performs,
 * while obviating the need to send all metrics to the server, only to
 * have them filtered out by the sample rate, i.e. no-ops.
 * See: https://github.com/DataDog/dd-agent/blob/331c507f164ec7bd256a32beb3889d4fafb0ba7e/aggregator.py#L205
 */ function $5fd69b7d1dfb75f7$var$amplifySamples(data, sampleRate) {
    const amplifiedData = {};
    Object.keys(data).forEach((k)=>{
        // @ts-ignore TODO: fix noImplicitAny error here
        amplifiedData[k] = data[k] * Math.floor(1 / sampleRate);
    });
    return amplifiedData;
}
var $5fd69b7d1dfb75f7$export$2e2bcd8739ae039;
$5fd69b7d1dfb75f7$export$2e2bcd8739ae039 = class StatsdApiClient {
    constructor(authRequest, options = {}){
        this.authRequest = void 0;
        this.options = void 0;
        this.addToApiBatch = (0, $ausL7.default)(this.post.bind(this), {
            timeout: 1000
        });
        this.authRequest = authRequest;
        this.options = options;
    }
    post(data) {
        if (this.authRequest) fetch(this.authRequest.url, {
            method: "POST",
            body: JSON.stringify(data),
            ...this.authRequest.init
        }).then((response)=>response.ok ? Promise.resolve() : Promise.reject()).catch((e)=>{
            // Only handle exceptions for now (continue ignoring non-2XX responses)
            if (e && this.options.onError) this.options.onError(e);
        });
    }
    sendMetric(metric, data, options = {}) {
        const sampleRate = $5fd69b7d1dfb75f7$var$extractSampleRate(options);
        const include = Math.random() < sampleRate;
        if (include) {
            const payload = {
                data: data,
                metric: metric,
                tags: options.tags || []
            };
            if (options.eager) this.post(payload);
            else // This simulates the same sampling that datadog's statsd agent performs,
            // while obviating the need to send all metrics to the server, only to
            // have them filtered out by the sample rate, i.e. no-ops.
            // See: https://github.com/DataDog/dd-agent/blob/331c507f164ec7bd256a32beb3889d4fafb0ba7e/aggregator.py#L205
            this.addToApiBatch(payload);
        }
        return include;
    }
    event(title, text, options) {
        return this.sendMetric("event", {
            title: title,
            text: text
        }, options);
    }
    increment(data, options) {
        const amplifiedData = $5fd69b7d1dfb75f7$var$amplifySamples($5fd69b7d1dfb75f7$var$normalizeCounterData(data), $5fd69b7d1dfb75f7$var$extractSampleRate(options));
        return this.sendMetric("increment", amplifiedData, options);
    }
    decrement(data, options) {
        const amplifiedData = $5fd69b7d1dfb75f7$var$amplifySamples($5fd69b7d1dfb75f7$var$normalizeCounterData(data), $5fd69b7d1dfb75f7$var$extractSampleRate(options));
        return this.sendMetric("decrement", amplifiedData, options);
    }
    gauge(data, options) {
        return this.sendMetric("gauge", data, options);
    }
    histogram(data, options) {
        return this.sendMetric("histogram", data, options);
    }
    set(data, options) {
        return this.sendMetric("set", data, options);
    }
};

});
parcelRegister("ausL7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d76d1869d336696$export$2e2bcd8739ae039; });
/* Stores a set of items that can be processed simultaneously after a set timeout.
 *
 * Example:
 *
 * // Create the batch, which returns the function to add items
 * const addToBatch = timedBatch(function processItems(items) {
 *  items.forEach(item => doSomethingWithItem(item));
 * }, { timeout: 5000 });
 *
 * // Add things to the batch. After the timeout (5000ms), these items will be
 * // passed to the callback as an array ([4, 2] in this example)
 * addToBatch(4);
 * addToBatch(2);
 *
 * If we call `addToBatch` again after that timeout, a new batch will be
 * created and only those new items will be processed.
 */ function $9d76d1869d336696$export$2e2bcd8739ae039(callback, options = {}) {
    // @ts-ignore TODO: fix noImplicitAny error here
    let batchTimeout;
    const batch = [];
    const timeout = options.timeout || 1000;
    // @ts-ignore TODO: fix noImplicitAny error here
    return function addToBatch(item) {
        batch.push(item);
        // @ts-ignore TODO: fix noImplicitAny error here
        clearTimeout(batchTimeout);
        batchTimeout = setTimeout(()=>{
            callback(batch.slice());
            // clear the existing items
            batch.length = 0;
        }, timeout);
    };
}

});



parcelRegister("kvnVB", function(module, exports) {

$parcel$export(module.exports, "settings", function () { return $4a8b96c0bd1df481$export$a5a6e0b888b2c992; });
const $4a8b96c0bd1df481$export$a5a6e0b888b2c992 = ()=>window.__settings__ || {};

});

parcelRegister("628YF", function(module, exports) {

$parcel$export(module.exports, "captureExceptionWithTags", function () { return $c59254bfa2a5184a$export$b5a48fae6879d6b0; });
$parcel$export(module.exports, "captureMessageWithTags", function () { return $c59254bfa2a5184a$export$23bd8655596f5aa3; });
$parcel$export(module.exports, "captureMessageForResponse", function () { return $c59254bfa2a5184a$export$7198d1c73bebcc13; });

var $3XbtU = parcelRequire("3XbtU");
const $c59254bfa2a5184a$export$b5a48fae6879d6b0 = (e, tags = {}, extras = {})=>{
    return new Promise((resolve)=>{
        $3XbtU.withScope((scope)=>{
            Object.keys(tags).forEach((key)=>{
                scope.setTag(key, tags[key]);
            });
            Object.keys(extras).forEach((field)=>{
                scope.setExtra(field, extras[field]);
            });
            const id = $3XbtU.captureException(e);
            resolve(id);
        });
    });
};
const $c59254bfa2a5184a$export$23bd8655596f5aa3 = (m, tags = {}, extras = {})=>{
    return new Promise((resolve)=>{
        $3XbtU.withScope((scope)=>{
            Object.keys(tags).forEach((key)=>{
                scope.setTag(key, tags[key]);
            });
            Object.keys(extras).forEach((field)=>{
                scope.setExtra(field, extras[field]);
            });
            const id = $3XbtU.captureException(m);
            resolve(id);
        });
    });
};
async function $c59254bfa2a5184a$export$7198d1c73bebcc13(response, message) {
    const { status: status } = response;
    // @ts-ignore TODO: fix noImplicitAny error here
    let body;
    try {
        body = await response.text();
    } catch (e) {
        body = "";
    }
    $3XbtU.withScope((scope)=>{
        // Error body is extremely useful to be able to diagnose a problem. We don't
        // want it in the message because we don't want slightly different responses
        // to break grouping.
        // @ts-ignore TODO: fix noImplicitAny error here
        scope.setExtra("response", body);
        const messageWithStatus = `${message}: status ${status}`;
        // By default, Sentry groups similar messages (e.g. when only the status changes).
        // Disable that for this, we want to group by status.
        scope.setFingerprint([
            messageWithStatus
        ]);
        // We tried captureException here to have a file path, but the exception
        // stack trace is weird because this is in an async function.
        $3XbtU.captureMessage(messageWithStatus);
    });
}

});
parcelRegister("3XbtU", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $2e0fc9c273b6a272$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $2e0fc9c273b6a272$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $2e0fc9c273b6a272$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $2e0fc9c273b6a272$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $2e0fc9c273b6a272$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setContext", function () { return $2e0fc9c273b6a272$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtras", function () { return $2e0fc9c273b6a272$export$bb4922da0dd51b92; });
$parcel$export(module.exports, "setTags", function () { return $2e0fc9c273b6a272$export$74a8fb34822092e6; });
$parcel$export(module.exports, "setExtra", function () { return $2e0fc9c273b6a272$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setTag", function () { return $2e0fc9c273b6a272$export$a37d07ee78eb4569; });
$parcel$export(module.exports, "setUser", function () { return $2e0fc9c273b6a272$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "withScope", function () { return $2e0fc9c273b6a272$export$ec58d9285c204497; });
$parcel$export(module.exports, "startTransaction", function () { return $2e0fc9c273b6a272$export$e262da7ae6480481; });

var $l5MLt = parcelRequire("l5MLt");

var $4IkmO = parcelRequire("4IkmO");
/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2e0fc9c273b6a272$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $4IkmO.getCurrentHub)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $l5MLt.__spread)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $2e0fc9c273b6a272$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException = new Error("Sentry syntheticException");
    return $2e0fc9c273b6a272$var$callOnHub("captureException", exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $2e0fc9c273b6a272$export$45654777c133ae80(message, captureContext) {
    var syntheticException = new Error(message);
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return $2e0fc9c273b6a272$var$callOnHub("captureMessage", message, level, (0, $l5MLt.__assign)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $2e0fc9c273b6a272$export$1462b974fdcf6ba2(event) {
    return $2e0fc9c273b6a272$var$callOnHub("captureEvent", event);
}
function $2e0fc9c273b6a272$export$99d44f04437e9cb8(callback) {
    $2e0fc9c273b6a272$var$callOnHub("configureScope", callback);
}
function $2e0fc9c273b6a272$export$efda9a273d7a036d(breadcrumb) {
    $2e0fc9c273b6a272$var$callOnHub("addBreadcrumb", breadcrumb);
}
function $2e0fc9c273b6a272$export$2f04de43fe27971a(name, context) {
    $2e0fc9c273b6a272$var$callOnHub("setContext", name, context);
}
function $2e0fc9c273b6a272$export$bb4922da0dd51b92(extras) {
    $2e0fc9c273b6a272$var$callOnHub("setExtras", extras);
}
function $2e0fc9c273b6a272$export$74a8fb34822092e6(tags) {
    $2e0fc9c273b6a272$var$callOnHub("setTags", tags);
}
function $2e0fc9c273b6a272$export$8e8e7789d42ed61d(key, extra) {
    $2e0fc9c273b6a272$var$callOnHub("setExtra", key, extra);
}
function $2e0fc9c273b6a272$export$a37d07ee78eb4569(key, value) {
    $2e0fc9c273b6a272$var$callOnHub("setTag", key, value);
}
function $2e0fc9c273b6a272$export$8b6bb3dd62a01be2(user) {
    $2e0fc9c273b6a272$var$callOnHub("setUser", user);
}
function $2e0fc9c273b6a272$export$ec58d9285c204497(callback) {
    $2e0fc9c273b6a272$var$callOnHub("withScope", callback);
}
function $2e0fc9c273b6a272$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $2e0fc9c273b6a272$var$callOnHub.apply(void 0, (0, $l5MLt.__spread)([
        "_invokeClient",
        method
    ], args));
}
function $2e0fc9c273b6a272$export$e262da7ae6480481(context, customSamplingContext) {
    return $2e0fc9c273b6a272$var$callOnHub("startTransaction", (0, $l5MLt.__assign)({}, context), customSamplingContext);
}

});
parcelRegister("l5MLt", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $f5afe4435b7da213$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $f5afe4435b7da213$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $f5afe4435b7da213$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $f5afe4435b7da213$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $f5afe4435b7da213$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__exportStar", function () { return $f5afe4435b7da213$export$f33643c0debef087; });
$parcel$export(module.exports, "__values", function () { return $f5afe4435b7da213$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $f5afe4435b7da213$export$8d051b38c9118094; });
$parcel$export(module.exports, "__spread", function () { return $f5afe4435b7da213$export$afc72e2116322959; });
$parcel$export(module.exports, "__spreadArrays", function () { return $f5afe4435b7da213$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__importStar", function () { return $f5afe4435b7da213$export$c21735bcef00d192; });
$parcel$export(module.exports, "__importDefault", function () { return $f5afe4435b7da213$export$da59b14a69baef04; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $f5afe4435b7da213$var$extendStatics = function(d, b) {
    $f5afe4435b7da213$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $f5afe4435b7da213$var$extendStatics(d, b);
};
function $f5afe4435b7da213$export$a8ba968b8961cb8a(d, b) {
    $f5afe4435b7da213$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5afe4435b7da213$export$18ce0697a983be9b = function() {
    $f5afe4435b7da213$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5afe4435b7da213$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5afe4435b7da213$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5afe4435b7da213$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5afe4435b7da213$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5afe4435b7da213$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5afe4435b7da213$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5afe4435b7da213$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $f5afe4435b7da213$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $f5afe4435b7da213$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $f5afe4435b7da213$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5afe4435b7da213$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5afe4435b7da213$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5afe4435b7da213$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5afe4435b7da213$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5afe4435b7da213$export$10c90e4f7922046c(v) {
    return this instanceof $f5afe4435b7da213$export$10c90e4f7922046c ? (this.v = v, this) : new $f5afe4435b7da213$export$10c90e4f7922046c(v);
}
function $f5afe4435b7da213$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5afe4435b7da213$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5afe4435b7da213$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5afe4435b7da213$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5afe4435b7da213$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5afe4435b7da213$export$19a8beecd37a4c45 === "function" ? $f5afe4435b7da213$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5afe4435b7da213$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $f5afe4435b7da213$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $f5afe4435b7da213$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5afe4435b7da213$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $f5afe4435b7da213$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("4IkmO", function(module, exports) {

$parcel$export(module.exports, "Hub", function () { return $36eb11ebdaa44f36$export$8c41bb232f1008b1; });
$parcel$export(module.exports, "makeMain", function () { return $36eb11ebdaa44f36$export$4188a14ad302d1bc; });
$parcel$export(module.exports, "getHubFromCarrier", function () { return $36eb11ebdaa44f36$export$bfa8a924a84a76b7; });
$parcel$export(module.exports, "getCurrentHub", function () { return $36eb11ebdaa44f36$export$a07cdf6544bbd7c; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("adAOX");
var $iae15 = parcelRequire("iae15");
var $79aQT = parcelRequire("79aQT");
var $iHHw0 = parcelRequire("iHHw0");
var $7HZmq = parcelRequire("7HZmq");
var $iEupb = parcelRequire("iEupb");

var $7mSNn = parcelRequire("7mSNn");

var $l6Sat = parcelRequire("l6Sat");

var $jA7RW = parcelRequire("jA7RW");
var $36eb11ebdaa44f36$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $36eb11ebdaa44f36$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $36eb11ebdaa44f36$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $l6Sat.Scope)();
        if (_version === void 0) _version = $36eb11ebdaa44f36$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        if (client) this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $l6Sat.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : (0, $iEupb.uuid4)();
        if (event.type !== "transaction") this._lastEventId = eventId;
        this._invokeClient("captureEvent", event, (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $36eb11ebdaa44f36$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $79aQT.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $l5MLt.__assign)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $iae15.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $36eb11ebdaa44f36$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $36eb11ebdaa44f36$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureSession = function(endSession) {
        if (endSession === void 0) endSession = false;
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) session.close();
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) scope.setSession();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = (0, $iHHw0.getGlobalObject)();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new (0, $jA7RW.Session)((0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), userAgent && {
            userAgent: userAgent
        }), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === "ok") currentSession.update({
                status: "exited"
            });
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */ Hub.prototype._sendSessionUpdate = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) client.captureSession(session);
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $l5MLt.__spread)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $36eb11ebdaa44f36$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $36eb11ebdaa44f36$export$19eade501500c6c1() {
    var carrier = (0, $iHHw0.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $36eb11ebdaa44f36$export$4188a14ad302d1bc(hub) {
    var registry = $36eb11ebdaa44f36$export$19eade501500c6c1();
    var oldHub = $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
    $36eb11ebdaa44f36$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $36eb11ebdaa44f36$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $36eb11ebdaa44f36$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$36eb11ebdaa44f36$var$hasHubOnCarrier(registry) || $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry).isOlderThan($36eb11ebdaa44f36$export$24a86ef7798177e4)) $36eb11ebdaa44f36$export$849f05434e95d2f2(registry, new $36eb11ebdaa44f36$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $7HZmq.isNodeEnv)()) return $36eb11ebdaa44f36$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
}
function $36eb11ebdaa44f36$export$1c4d656130202699() {
    (0, $7mSNn.IS_DEBUG_BUILD) && (0, $iae15.logger).warn("Function `getActiveDomain` is deprecated and will be removed in a future version.");
    var sentry = $36eb11ebdaa44f36$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $36eb11ebdaa44f36$var$getHubFromActiveDomain(registry) {
    try {
        var sentry = $36eb11ebdaa44f36$export$19eade501500c6c1().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$36eb11ebdaa44f36$var$hasHubOnCarrier(activeDomain) || $36eb11ebdaa44f36$export$bfa8a924a84a76b7(activeDomain).isOlderThan($36eb11ebdaa44f36$export$24a86ef7798177e4)) {
            var registryHubTopStack = $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry).getStackTop();
            $36eb11ebdaa44f36$export$849f05434e95d2f2(activeDomain, new $36eb11ebdaa44f36$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $l6Sat.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $36eb11ebdaa44f36$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $36eb11ebdaa44f36$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $36eb11ebdaa44f36$export$bfa8a924a84a76b7(carrier) {
    return (0, $iHHw0.getGlobalSingleton)("hub", function() {
        return new $36eb11ebdaa44f36$export$8c41bb232f1008b1();
    }, carrier);
}
function $36eb11ebdaa44f36$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("adAOX", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", function () { return (parcelRequire("iHHw0")).getGlobalObject; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return (parcelRequire("iHHw0")).getGlobalSingleton; });
$parcel$export(module.exports, "isPlainObject", function () { return (parcelRequire("7GcQw")).isPlainObject; });
$parcel$export(module.exports, "isThenable", function () { return (parcelRequire("7GcQw")).isThenable; });
$parcel$export(module.exports, "consoleSandbox", function () { return (parcelRequire("iae15")).consoleSandbox; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("iae15")).logger; });
$parcel$export(module.exports, "uuid4", function () { return (parcelRequire("iEupb")).uuid4; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return (parcelRequire("kd4fD")).dropUndefinedKeys; });
$parcel$export(module.exports, "SyncPromise", function () { return (parcelRequire("8lVec")).SyncPromise; });





parcelRequire("iHHw0");

parcelRequire("7GcQw");
parcelRequire("iae15");

parcelRequire("iEupb");

var $7HZmq = parcelRequire("7HZmq");

parcelRequire("kd4fD");







parcelRequire("8lVec");

var $79aQT = parcelRequire("79aQT");





$parcel$exportWildcard(module.exports, $7HZmq);
$parcel$exportWildcard(module.exports, $79aQT);

});
parcelRegister("iHHw0", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $d9ddff5de85e8786$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $d9ddff5de85e8786$export$7e223ec222791509; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $7HZmq = parcelRequire("7HZmq");
var $d9ddff5de85e8786$var$fallbackGlobalObject = {};
function $d9ddff5de85e8786$export$256479dc0cea61c4() {
    return (0, $7HZmq.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== "undefined" ? self : $d9ddff5de85e8786$var$fallbackGlobalObject;
}
function $d9ddff5de85e8786$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $d9ddff5de85e8786$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});
parcelRegister("7HZmq", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; }, function (v) { return dynamicRequire = v; });
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $cpA2Q = parcelRequire("cpA2Q");

var $8ovux = parcelRequire("8ovux");
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $cpA2Q.isBrowserBundle)() && Object.prototype.toString.call(typeof $8ovux !== "undefined" ? $8ovux : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, "process").cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("cpA2Q", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $9093c798a44a0529$export$2928c40372e623c0; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $9093c798a44a0529$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}

});

parcelRegister("8ovux", function(module, exports) {
// shim for using process in browser
var $61c8fe3383bdc9e8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $61c8fe3383bdc9e8$var$cachedSetTimeout;
var $61c8fe3383bdc9e8$var$cachedClearTimeout;
function $61c8fe3383bdc9e8$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $61c8fe3383bdc9e8$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $61c8fe3383bdc9e8$var$cachedSetTimeout = setTimeout;
        else $61c8fe3383bdc9e8$var$cachedSetTimeout = $61c8fe3383bdc9e8$var$defaultSetTimout;
    } catch (e) {
        $61c8fe3383bdc9e8$var$cachedSetTimeout = $61c8fe3383bdc9e8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $61c8fe3383bdc9e8$var$cachedClearTimeout = clearTimeout;
        else $61c8fe3383bdc9e8$var$cachedClearTimeout = $61c8fe3383bdc9e8$var$defaultClearTimeout;
    } catch (e) {
        $61c8fe3383bdc9e8$var$cachedClearTimeout = $61c8fe3383bdc9e8$var$defaultClearTimeout;
    }
})();
function $61c8fe3383bdc9e8$var$runTimeout(fun) {
    if ($61c8fe3383bdc9e8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($61c8fe3383bdc9e8$var$cachedSetTimeout === $61c8fe3383bdc9e8$var$defaultSetTimout || !$61c8fe3383bdc9e8$var$cachedSetTimeout) && setTimeout) {
        $61c8fe3383bdc9e8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $61c8fe3383bdc9e8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $61c8fe3383bdc9e8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $61c8fe3383bdc9e8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $61c8fe3383bdc9e8$var$runClearTimeout(marker) {
    if ($61c8fe3383bdc9e8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($61c8fe3383bdc9e8$var$cachedClearTimeout === $61c8fe3383bdc9e8$var$defaultClearTimeout || !$61c8fe3383bdc9e8$var$cachedClearTimeout) && clearTimeout) {
        $61c8fe3383bdc9e8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $61c8fe3383bdc9e8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $61c8fe3383bdc9e8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $61c8fe3383bdc9e8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $61c8fe3383bdc9e8$var$queue = [];
var $61c8fe3383bdc9e8$var$draining = false;
var $61c8fe3383bdc9e8$var$currentQueue;
var $61c8fe3383bdc9e8$var$queueIndex = -1;
function $61c8fe3383bdc9e8$var$cleanUpNextTick() {
    if (!$61c8fe3383bdc9e8$var$draining || !$61c8fe3383bdc9e8$var$currentQueue) return;
    $61c8fe3383bdc9e8$var$draining = false;
    if ($61c8fe3383bdc9e8$var$currentQueue.length) $61c8fe3383bdc9e8$var$queue = $61c8fe3383bdc9e8$var$currentQueue.concat($61c8fe3383bdc9e8$var$queue);
    else $61c8fe3383bdc9e8$var$queueIndex = -1;
    if ($61c8fe3383bdc9e8$var$queue.length) $61c8fe3383bdc9e8$var$drainQueue();
}
function $61c8fe3383bdc9e8$var$drainQueue() {
    if ($61c8fe3383bdc9e8$var$draining) return;
    var timeout = $61c8fe3383bdc9e8$var$runTimeout($61c8fe3383bdc9e8$var$cleanUpNextTick);
    $61c8fe3383bdc9e8$var$draining = true;
    var len = $61c8fe3383bdc9e8$var$queue.length;
    while(len){
        $61c8fe3383bdc9e8$var$currentQueue = $61c8fe3383bdc9e8$var$queue;
        $61c8fe3383bdc9e8$var$queue = [];
        while(++$61c8fe3383bdc9e8$var$queueIndex < len)if ($61c8fe3383bdc9e8$var$currentQueue) $61c8fe3383bdc9e8$var$currentQueue[$61c8fe3383bdc9e8$var$queueIndex].run();
        $61c8fe3383bdc9e8$var$queueIndex = -1;
        len = $61c8fe3383bdc9e8$var$queue.length;
    }
    $61c8fe3383bdc9e8$var$currentQueue = null;
    $61c8fe3383bdc9e8$var$draining = false;
    $61c8fe3383bdc9e8$var$runClearTimeout(timeout);
}
$61c8fe3383bdc9e8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $61c8fe3383bdc9e8$var$queue.push(new $61c8fe3383bdc9e8$var$Item(fun, args));
    if ($61c8fe3383bdc9e8$var$queue.length === 1 && !$61c8fe3383bdc9e8$var$draining) $61c8fe3383bdc9e8$var$runTimeout($61c8fe3383bdc9e8$var$drainQueue);
};
// v8 likes predictible objects
function $61c8fe3383bdc9e8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$61c8fe3383bdc9e8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$61c8fe3383bdc9e8$var$process.title = "browser";
$61c8fe3383bdc9e8$var$process.browser = true;
$61c8fe3383bdc9e8$var$process.env = {};
$61c8fe3383bdc9e8$var$process.argv = [];
$61c8fe3383bdc9e8$var$process.version = ""; // empty string to avoid regexp issues
$61c8fe3383bdc9e8$var$process.versions = {};
function $61c8fe3383bdc9e8$var$noop() {}
$61c8fe3383bdc9e8$var$process.on = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.addListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.once = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.off = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.removeListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.removeAllListeners = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.emit = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.prependListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.prependOnceListener = $61c8fe3383bdc9e8$var$noop;
$61c8fe3383bdc9e8$var$process.listeners = function(name) {
    return [];
};
$61c8fe3383bdc9e8$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$61c8fe3383bdc9e8$var$process.cwd = function() {
    return "/";
};
$61c8fe3383bdc9e8$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$61c8fe3383bdc9e8$var$process.umask = function() {
    return 0;
};

});



parcelRegister("7GcQw", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $59766ba098722c64$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $59766ba098722c64$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $59766ba098722c64$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $59766ba098722c64$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $59766ba098722c64$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $59766ba098722c64$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $59766ba098722c64$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $59766ba098722c64$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $59766ba098722c64$export$f5b060c2914b97c8; });
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $59766ba098722c64$var$objectToString = Object.prototype.toString;
function $59766ba098722c64$export$e6127cc7fe7395c3(wat) {
    switch($59766ba098722c64$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $59766ba098722c64$export$49034edbe6b62415(wat, Error);
    }
}
function $59766ba098722c64$var$isBuiltin(wat, ty) {
    return $59766ba098722c64$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $59766ba098722c64$export$9f9636d330b71954(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "ErrorEvent");
}
function $59766ba098722c64$export$ef9e2056653f0c8e(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "DOMError");
}
function $59766ba098722c64$export$12e869b2a583f783(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "DOMException");
}
function $59766ba098722c64$export$844ec244b1367d54(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "String");
}
function $59766ba098722c64$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $59766ba098722c64$export$53b83ca8eaab0383(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "Object");
}
function $59766ba098722c64$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $59766ba098722c64$export$49034edbe6b62415(wat, Event);
}
function $59766ba098722c64$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $59766ba098722c64$export$49034edbe6b62415(wat, Element);
}
function $59766ba098722c64$export$49841c62b9eff15(wat) {
    return $59766ba098722c64$var$isBuiltin(wat, "RegExp");
}
function $59766ba098722c64$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $59766ba098722c64$export$bc2894c7158efbac(wat) {
    return $59766ba098722c64$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $59766ba098722c64$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
function $59766ba098722c64$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("iae15", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $d3940893e44babd4$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $d3940893e44babd4$export$af88d00dbe7f521; });

var $l5MLt = parcelRequire("l5MLt");

var $bx7l3 = parcelRequire("bx7l3");

var $iHHw0 = parcelRequire("iHHw0");
// TODO: Implement different loggers for different environments
var $d3940893e44babd4$var$global = (0, $iHHw0.getGlobalObject)();
/** Prefix for logging strings */ var $d3940893e44babd4$var$PREFIX = "Sentry Logger ";
var $d3940893e44babd4$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert"
];
function $d3940893e44babd4$export$cda52e2a8927a2ca(callback) {
    var global = (0, $iHHw0.getGlobalObject)();
    if (!("console" in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $d3940893e44babd4$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $bx7l3.IS_DEBUG_BUILD) $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $d3940893e44babd4$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $d3940893e44babd4$var$global.console)[name].apply(_a, (0, $l5MLt.__spread)([
                    $d3940893e44babd4$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $d3940893e44babd4$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $d3940893e44babd4$export$af88d00dbe7f521;
if (0, $bx7l3.IS_DEBUG_BUILD) $d3940893e44babd4$export$af88d00dbe7f521 = (0, $iHHw0.getGlobalSingleton)("logger", $d3940893e44babd4$var$makeLogger);
else $d3940893e44babd4$export$af88d00dbe7f521 = $d3940893e44babd4$var$makeLogger();

});
parcelRegister("bx7l3", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $865878152573f007$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $865878152573f007$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});


parcelRegister("iEupb", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $d9438c3f44f9bf80$export$19f53698e68b2496; });

var $l5MLt = parcelRequire("l5MLt");

var $iHHw0 = parcelRequire("iHHw0");

var $kd4fD = parcelRequire("kd4fD");

var $6hkJG = parcelRequire("6hkJG");
function $d9438c3f44f9bf80$export$19f53698e68b2496() {
    var global = (0, $iHHw0.getGlobalObject)();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $d9438c3f44f9bf80$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $d9438c3f44f9bf80$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
function $d9438c3f44f9bf80$export$4157119e2b157127(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = $d9438c3f44f9bf80$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return firstException.type + ": " + firstException.value;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
function $d9438c3f44f9bf80$export$f26508487bf83ee7(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
function $d9438c3f44f9bf80$export$c69a9a0313b03bb1(event, newMechanism) {
    var firstException = $d9438c3f44f9bf80$var$getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: "generic",
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, $l5MLt.__assign)((0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && "data" in newMechanism) {
        var mergedData = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, currentMechanism && currentMechanism.data), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $d9438c3f44f9bf80$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $d9438c3f44f9bf80$export$d364f2020ab30578(input) {
    var match = input.match($d9438c3f44f9bf80$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
function $d9438c3f44f9bf80$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $6hkJG.snipLine)(line, 0);
    });
    frame.context_line = (0, $6hkJG.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $6hkJG.snipLine)(line, 0);
    });
}
function $d9438c3f44f9bf80$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
function $d9438c3f44f9bf80$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $kd4fD.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

});
parcelRegister("kd4fD", function(module, exports) {

$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $eb6851b783b571b8$export$e73679ffaf56810e; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $eb6851b783b571b8$export$d25f2688db1bb433; });

var $l5MLt = parcelRequire("l5MLt");

var $bqYW0 = parcelRequire("bqYW0");

var $7GcQw = parcelRequire("7GcQw");

var $6hkJG = parcelRequire("6hkJG");
function $eb6851b783b571b8$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        $eb6851b783b571b8$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $eb6851b783b571b8$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $eb6851b783b571b8$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $eb6851b783b571b8$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
}
function $eb6851b783b571b8$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $eb6851b783b571b8$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
function $eb6851b783b571b8$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $7GcQw.isError)(value)) newObj = (0, $l5MLt.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $eb6851b783b571b8$var$getOwnProperties(value));
    else if ((0, $7GcQw.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $l5MLt.__assign)({
            type: event_1.type,
            target: $eb6851b783b571b8$var$serializeEventTarget(event_1.target),
            currentTarget: $eb6851b783b571b8$var$serializeEventTarget(event_1.currentTarget)
        }, $eb6851b783b571b8$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== "undefined" && (0, $7GcQw.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $eb6851b783b571b8$var$serializeEventTarget(target) {
    try {
        return (0, $7GcQw.isElement)(target) ? (0, $bqYW0.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $eb6851b783b571b8$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $eb6851b783b571b8$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($eb6851b783b571b8$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $6hkJG.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6hkJG.truncate)(serialized, maxLength);
    }
    return "";
}
function $eb6851b783b571b8$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $7GcQw.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $l5MLt.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== "undefined") rv[key] = $eb6851b783b571b8$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($eb6851b783b571b8$export$d25f2688db1bb433);
    return val;
}
function $eb6851b783b571b8$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $7GcQw.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bqYW0", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $853163c0efc81663$export$5647df6b7814ac86; });

var $iHHw0 = parcelRequire("iHHw0");

var $7GcQw = parcelRequire("7GcQw");
function $853163c0efc81663$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $853163c0efc81663$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $853163c0efc81663$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + '="' + keyAttrPair[1] + '"]');
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $7GcQw.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}
function $853163c0efc81663$export$1cfafeee2987818b() {
    var global = (0, $iHHw0.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return "";
    }
}

});

parcelRegister("6hkJG", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $49246a4a3d15c781$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $49246a4a3d15c781$export$4215662d762d6f9d; });

var $7GcQw = parcelRequire("7GcQw");
function $49246a4a3d15c781$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $49246a4a3d15c781$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
function $49246a4a3d15c781$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $49246a4a3d15c781$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $7GcQw.isString)(value)) return false;
    if ((0, $7GcQw.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}
function $49246a4a3d15c781$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}

});



parcelRegister("8lVec", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $614cad2a7a9a568d$export$6f292d4960313241; });
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $7GcQw = parcelRequire("7GcQw");
function $614cad2a7a9a568d$export$1fda8aa4d135f8aa(value) {
    return new $614cad2a7a9a568d$export$6f292d4960313241(function(resolve) {
        resolve(value);
    });
}
function $614cad2a7a9a568d$export$78e43115b553f358(reason) {
    return new $614cad2a7a9a568d$export$6f292d4960313241(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $614cad2a7a9a568d$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */ ;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult(1 /* RESOLVED */ , value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult(2 /* REJECTED */ , reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== 0 /* PENDING */ ) return;
            if ((0, $7GcQw.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === 0 /* PENDING */ ) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler[0]) return;
                if (_this._state === 1 /* RESOLVED */ ) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](_this._value);
                if (_this._state === 2 /* REJECTED */ ) handler[2](_this._value);
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._handlers.push([
                false,
                function(result) {
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                function(reason) {
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}();

});

parcelRegister("79aQT", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; }, function (v) { return dateTimestampInSeconds = v; });
$parcel$export(module.exports, "timestampInSeconds", function () { return timestampInSeconds; }, function (v) { return timestampInSeconds = v; });

var $iHHw0 = parcelRequire("iHHw0");

var $7HZmq = parcelRequire("7HZmq");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $iHHw0.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $7HZmq.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $7HZmq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $iHHw0.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = "none";
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = "timeOrigin";
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = "dateNow";
    return dateNow;
}();

});


parcelRegister("7mSNn", function(module, exports) {

$parcel$export(module.exports, "IS_DEBUG_BUILD", function () { return $55d517b6a811b3c0$export$48a8984ec0bf2e44; });
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $55d517b6a811b3c0$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === "undefined" ? true : __SENTRY_DEBUG__;

});

parcelRegister("l6Sat", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $f5e42d1fd59223df$export$775b6bb06e53a214; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $f5e42d1fd59223df$export$8e4e25f54d456511; });

var $l5MLt = parcelRequire("l5MLt");
parcelRequire("adAOX");
var $79aQT = parcelRequire("79aQT");
var $iHHw0 = parcelRequire("iHHw0");
var $7GcQw = parcelRequire("7GcQw");
var $8lVec = parcelRequire("8lVec");
/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */ var $f5e42d1fd59223df$var$MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $f5e42d1fd59223df$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */ this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $l5MLt.__spread)(scope._breadcrumbs);
            newScope._tags = (0, $l5MLt.__assign)({}, scope._tags);
            newScope._extra = (0, $l5MLt.__assign)({}, scope._extra);
            newScope._contexts = (0, $l5MLt.__assign)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $l5MLt.__spread)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getRequestSession = function() {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setRequestSession = function(requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), captureContext._tags);
            this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), captureContext._extra);
            this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $7GcQw.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), captureContext.tags);
            this._extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), captureContext.extra);
            this._contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === "number" ? Math.min(maxBreadcrumbs, $f5e42d1fd59223df$var$MAX_BREADCRUMBS) : $f5e42d1fd59223df$var$MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        var mergedBreadcrumb = (0, $l5MLt.__assign)({
            timestamp: (0, $79aQT.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = (0, $l5MLt.__spread)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0, $l5MLt.__assign)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = (0, $l5MLt.__assign)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $l5MLt.__spread)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0, $l5MLt.__spread)($f5e42d1fd59223df$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */ Scope.prototype.setSDKProcessingMetadata = function(newData) {
        this._sdkProcessingMetadata = (0, $l5MLt.__assign)((0, $l5MLt.__assign)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $8lVec.SyncPromise)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor((0, $l5MLt.__assign)({}, event), hint);
                if ((0, $7GcQw.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Returns the global event processors.
 */ function $f5e42d1fd59223df$var$getGlobalEventProcessors() {
    return (0, $iHHw0.getGlobalSingleton)("globalEventProcessors", function() {
        return [];
    });
}
function $f5e42d1fd59223df$export$8e4e25f54d456511(callback) {
    $f5e42d1fd59223df$var$getGlobalEventProcessors().push(callback);
}

});

parcelRegister("jA7RW", function(module, exports) {

$parcel$export(module.exports, "Session", function () { return $e4177bb6586dac64$export$1fb4852a55678982; });
parcelRequire("adAOX");
var $kd4fD = parcelRequire("kd4fD");
var $79aQT = parcelRequire("79aQT");
var $iEupb = parcelRequire("iEupb");
/**
 * @inheritdoc
 */ var $e4177bb6586dac64$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $iEupb.uuid4)();
        this.duration = 0;
        this.status = "ok";
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = (0, $79aQT.timestampInSeconds)();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!this.did && !context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || (0, $79aQT.timestampInSeconds)();
        if (context.ignoreDuration) this.ignoreDuration = context.ignoreDuration;
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $iEupb.uuid4)();
        if (context.init !== undefined) this.init = context.init;
        if (!this.did && context.did) this.did = "" + context.did;
        if (typeof context.started === "number") this.started = context.started;
        if (this.ignoreDuration) this.duration = undefined;
        else if (typeof context.duration === "number") this.duration = context.duration;
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (!this.ipAddress && context.ipAddress) this.ipAddress = context.ipAddress;
        if (!this.userAgent && context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === "number") this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === "ok") this.update({
            status: "exited"
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $kd4fD.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === "number" || typeof this.did === "string" ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            }
        });
    };
    return Session;
}();

});





parcelRegister("1ZBmx", function(module, exports) {

$parcel$export(module.exports, "getSsrState", function () { return $80e073600c742ec7$export$8b26fc8110ba9d33; });
$parcel$export(module.exports, "getSsrStats", function () { return $80e073600c742ec7$export$f59eb203d31e7447; });
$parcel$export(module.exports, "IS_SERVER", function () { return $80e073600c742ec7$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "appWasServerSideRendered", function () { return $80e073600c742ec7$export$642262419f51fae8; });
$parcel$export(module.exports, "canHydrateFromSsr", function () { return $80e073600c742ec7$export$ff492be938a8806a; });
$parcel$export(module.exports, "getInitialOrBucketState", function () { return $80e073600c742ec7$export$230aeef4b9e0f6e3; });
const $80e073600c742ec7$export$93484e5d50f84920 = "__ssr_state__";
const $80e073600c742ec7$export$d0f43d4b04198724 = "__ssr_stats__";
const $80e073600c742ec7$export$8b26fc8110ba9d33 = ()=>window[$80e073600c742ec7$export$93484e5d50f84920] || {};
const $80e073600c742ec7$export$f59eb203d31e7447 = ()=>window[$80e073600c742ec7$export$d0f43d4b04198724] || {};
/**
 * Private constant to make sure we don't need to keep calling Object.keys
 * but we can still mock the public API easily.
 */ const $80e073600c742ec7$var$APP_DID_SSR = Object.keys($80e073600c742ec7$export$8b26fc8110ba9d33()).length > 0;
const $80e073600c742ec7$export$d2f4d8e74279c212 = undefined;
const $80e073600c742ec7$export$642262419f51fae8 = ()=>$80e073600c742ec7$var$APP_DID_SSR;
const $80e073600c742ec7$export$ff492be938a8806a = ()=>!$80e073600c742ec7$export$d2f4d8e74279c212 && $80e073600c742ec7$export$642262419f51fae8();
const $80e073600c742ec7$export$230aeef4b9e0f6e3 = ()=>$80e073600c742ec7$export$642262419f51fae8() ? $80e073600c742ec7$export$8b26fc8110ba9d33().reduxStoreState : // eslint-disable-next-line no-restricted-properties
    window.__initial_state__;

});


var $31lGp = parcelRequire("31lGp");

var $M3cyx = parcelRequire("M3cyx");

var $1ZBmx = parcelRequire("1ZBmx");
/**
 * Convert performance.timing values to be relative to
 * the initiating event (performance.timing.navigationStart)
 */ function $647af132c5a4c456$var$getNormalizedTimings() {
    const normalized = {};
    const { timing: timing } = window.performance;
    const { navigationStart: navigationStart } = timing;
    // The performance.timing object inherits its properties
    for(const timingKey in timing)// Take only the timing values, no functions.
    // @ts-ignore TODO: fix noImplicitAny error here
    if (typeof timing[timingKey] === "number") // @ts-ignore TODO: fix noImplicitAny error here
    normalized[`performance.${timingKey}`] = // Note: some values will be zero, so we just copy those
    // @ts-ignore TODO: fix noImplicitAny error here
    timing[timingKey] ? timing[timingKey] - navigationStart : 0;
    // Putting back the original navigationStart value.
    // Don't want to normalize the base timing point.
    // @ts-ignore TODO: fix noImplicitAny error here
    normalized["performance.navigationStart"] = navigationStart;
    return normalized;
}
function $647af132c5a4c456$var$initPerformanceTimingMetrics() {
    window.addEventListener("load", ()=>{
        const stats = {
            ...$647af132c5a4c456$var$getNormalizedTimings(),
            ...(0, $1ZBmx.getSsrStats)()
        };
        function sendTimings() {
            if (document.hidden || !window.performance.okayToSendMetrics) return;
            (0, $M3cyx.statsdApiClient).histogram(stats, {
                tags: [
                    "source:frontbucket",
                    `loadType:full_page`,
                    `view_name:${(0, $31lGp.default)}`,
                    `appWasServerSideRendered:${(0, $1ZBmx.appWasServerSideRendered)()}`
                ]
            });
        }
        // Using setTimeout to make sure this executes after load
        // event callbacks have finished firing (so that
        // 'performance.timing.loadEventEnd' will have a value)
        setTimeout(sendTimings, 0);
    });
}
if (window.performance.okayToSendMetrics) $647af132c5a4c456$var$initPerformanceTimingMetrics();

})();
//# sourceMappingURL=performance-timing.js.map
